import React, { ReactNode, type FunctionComponent } from 'react'
import { CardGridWrapper } from './card-grid.styles'

type CardGridProps = {
    children: ReactNode,
}

export const CardGrid: FunctionComponent<CardGridProps> = ( { children } ) => {
	return (
		<CardGridWrapper>
			{children}
		</CardGridWrapper>
	)
}
